<template>
  <section class="wrap-link">
    <ul class="link-list" id="box">
      <li class="friend-link fl" v-for="(img, i) of imgs" :key="i">
        <a :href="img.link" v-if="img.link" target="_blank">
          <img class="link-img"  :src="img.url" alt="friend-link">
        </a>
        <img class="link-img" v-else :src="img.url"  alt="friend-link">
      </li>
    </ul>
  </section>
</template>
<script>
export default {
  data () {
    return {
      originImg: [
        {url: './static/ys-images/client-ze.png', link: ''},
        {url: './static/ys-images/client-a4g.png', link: ''},
        {url: './static/ys-images/client-evo.png', link: ''},
        {url: './static/ys-images/client-apus.png', link: ''},
        // {url: './static/ys-images/client-flex.png', link: ''},
        {url: './static/ys-images/client-wise.png', link: ''},
        // {url: './static/ys-images/client-qubiq.png', link: ''},
        // {url: './static/ys-images/client-gorilla.png', link: ''},
        // {url: './static/ys-images/client-mobista.png', link: ''},
        {url: './static/ys-images/aff-plus.png', link: 'https://www.affplus.com/'},
        {url: './static/ys-images/aff-paying.png', link: 'https://www.affpaying.com'},
        {url: './static/ys-images/google-ad.png', link: ''},
        {url: './static/ys-images/propeller-ad.png', link: ''}
      ],
      imgs: [

      ]
    }
  },
  created () {
    this.imgs = [...this.originImg, ...this.originImg]
  }
}
</script>
<style lang="scss">
.wrap-link {
  width: 100%;
  overflow: hidden;
  padding: 2.5rem 0;
  background: #1c7ac5;
  .link-list {
    display: flex;
    align-items: center;
    list-style: none;
    overflow: hidden;
    width: 318rem;
    padding: 0;
    animation: move-link 25s linear infinite;

    .friend-link {
      width: 16.6875rem;
    }
    img {
      width: 14rem;
    }
  }
  @keyframes move-link {
    0% {
      transform: translateX(0);
    }
    3% {
      transform: translateX(-16.6875rem);
    }
    11% {
      transform: translateX(-16.6875rem);
    }
    14% {
      transform: translateX(-33.375rem);
    }
    22% {
      transform: translateX(-33.375rem);
    }
    25% {
      transform: translateX(-50.0625rem);
    }
    33% {
      transform: translateX(-50.0625rem);
    }
    36% {
      transform: translateX(-66.75rem);
    }
    44% {
      transform: translateX(-66.75rem);
    }
    47% {
      transform: translateX(-83.4375rem);
    }
    55% {
      transform: translateX(-83.4375rem);
    }
    58% {
      transform: translateX(-100.125rem);
    }
    66% {
      transform: translateX(-100.125rem);
    }
    69% {
      transform: translateX(-116.8125rem);
    }
    77% {
      transform: translateX(-116.8125rem);
    }
    80% {
      transform: translateX(-133.5rem);
    }
    88% {
      transform: translateX(-133.5rem);
    }
    92% {
      transform: translateX(-150.1875rem);
    }
    100% {
      transform: translateX(-150.1875rem);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FriendLink.vue